<template>
  <section class="report-header" v-if="presentation">
    <h4 class="report-header__name" :title="presentation.name">
      {{ presentation.name }}
    </h4>
    <span class="report-close-button" v-if="$route.name !== 'PresentationDetail'">
      <aha-icon
        name="close"
        height="16"
        width="16"
        viewBox="0 0 24 24"
        @click="closeReport"
        class="cursor-pointer text-base-70 hover:text-primary-90"
      />
    </span>
    <div
      class="report-header-reactions"
      v-if="hasAtLeastOneReactionWithValue"
    >
      <span v-for="reaction in reactions" :key="reaction.iconName" class="flex items-center mr-6">
        <img
          class="flex-grow-0 flex-shrink-0 inline-block mr-1"
          :src="reaction.icon"
          :alt="reaction.iconName"
          width="16"
          height="16"
        />
        <span class="number-of-reactions">
          {{ $func.formatter(reaction.numberOfReactions, 'KMB') }}
        </span>
      </span>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/util'
import constants from '@/constant'

import like from '@/assets/images/reactions/like.svg'
import heart from '@/assets/images/reactions/heart.svg'
import laugh from '@/assets/images/reactions/laugh.svg'
import sad from '@/assets/images/reactions/sad.svg'
import wow from '@/assets/images/reactions/wow.svg'

export default {
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isGeneratingReport: false,
    }
  },
  computed: {
    ...mapGetters('presentationReport', [
      'reactionsSummary',
      'isLoadingReport',
    ]),

    hasAtLeastOneReactionWithValue() {
      return this.presentation.reactions &&
            Object.values(this.presentation.reactions).some((reaction) => reaction === true) &&
            this.reactions.length > 0
    },

    reactions() {
      const reactionData = this.isLoadingReport ? this.presentation : this.reactionsSummary
      const reactions = [
        {
          icon: like,
          iconName: 'like',
          numberOfReactions: reactionData.numberOfLikes,
        },
        {
          icon: heart,
          iconName: 'heart',
          numberOfReactions: reactionData.numberOfHearts,
        },
        {
          icon: laugh,
          iconName: 'laugh',
          numberOfReactions: reactionData.numberOfLaughs,
        },
        {
          icon: wow,
          iconName: 'wow',
          numberOfReactions: reactionData.numberOfWows,
        },
        {
          icon: sad,
          iconName: 'sad',
          numberOfReactions: reactionData.numberOfSads,
        },
      ]

      return reactions
        .filter((reaction) => reaction.numberOfReactions)
        .sort((a, b) => b.numberOfReactions - a.numberOfReactions)
    },
  },
  methods: {
    ...mapActions('presentationReport', ['clearPresentationReportAction', 'unsubscribeReportAction']),
    closeReport() {
      document.body.classList.remove('no-scroll')
      this.unsubscribeReportAction()
      this.clearPresentationReportAction()
      if (this.$route.name === 'PresentationDetail') {
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Report > Hide report')
      } else {
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Report > Hide report')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .report-header__name {
    @apply font-bold text-base mb-4;
    width: calc(100% - 40px);
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
  }
  .report-header-reactions {
    @apply flex mb-4 relative bg-base-0 px-4 py-2 rounded-lg;
    box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  }
  .report-close-button {
    @apply absolute right-4 top-4;
  }
  .number-of-reactions {
    @apply mr-3;

    &:last-child {
      @apply mr-0;
    }
  }
</style>
